import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { INITIATIVES } from "@/data/mock";
import { FadeUp } from "@/components/shared/RevealText";

export default function Initiatives() {
    return (
        <section className="relative border-t border-ink/10 bg-slate-25 py-24 md:py-32" data-testid="initiatives-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4">Ch. 05 · Featured initiatives</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-ink md:text-[64px]">
                            Programs already
                            <br />
                            in <span className="serif-italic text-pink">motion</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-slate-600 md:text-[16px]">
                            Three flagship community initiatives you can join, contribute to, or track — each with a
                            dedicated request pipeline on this platform.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
                    {INITIATIVES.map((it, i) => (
                        <motion.article
                            key={it.id}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            className="group relative"
                            data-testid={`initiative-card-${it.id}`}
                        >
                            <div className="relative aspect-[4/5] overflow-hidden rounded-[24px] border border-ink/10 bg-white">
                                <img
                                    src={it.image}
                                    alt={it.title}
                                    className="h-full w-full object-cover grayscale-[10%] transition-transform duration-700 group-hover:scale-105"
                                />
                                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
                                <div className="absolute left-5 top-5 rounded-full border border-white/40 bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.24em] text-white backdrop-blur-md">
                                    {it.tag}
                                </div>
                                <div className="absolute inset-x-5 bottom-5 text-white">
                                    <h3 className="font-display text-[22px] font-semibold leading-tight tracking-tight">
                                        {it.title}
                                    </h3>
                                    <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-white/85">
                                        {it.body}
                                    </p>
                                    <div className="mt-4 flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.24em]">
                                        Explore <ArrowUpRight className="h-4 w-4" />
                                    </div>
                                </div>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
